import { useMutation } from '@tanstack/react-query';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { GetPreSignedUrl, SignWetInkDocumentUploadDto } from '@dealstack/shared/lib/generated';

export const useSignWetInkDocumentUploadUrl = (options: {
	dealId: string;
	programmeId: string;
	documentWorkflowInstanceId: string;
}) => {
	const { dealId, programmeId, documentWorkflowInstanceId } = options;

	return useMutation({
		mutationFn: async (body: SignWetInkDocumentUploadDto) => {
			const endpoint = formatUnicorn(
				API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_DOCUMENTWORKFLOWINSTANCEID_SIGN_WET_INK_UPLOAD_POST,
				{
					dealId,
					programmeId,
					documentWorkflowInstanceId,
				}
			);

			const response = await makeRequest<ApiV1.Response<GetPreSignedUrl>>({
				endpoint,
				method: HTTP_METHOD.POST,
				body: JSON.stringify(body),
			});

			return response.payload;
		},
	});
};
